import { action } from 'sky-engine/api/index'

import { POC_MNG, STEP_DATA, PROJECT_MONITOR, EVN_CONFIRM_MNG } from '@/api/apiModules'
/**
 * 更新步骤
 * @param {*} data
 * @returns
 */
export function updateFlowStatus(data) {
  return action(POC_MNG, 'updateFlowStatus', data)
}

/**
 * 创建项目
 * @param {*} data
 * @returns
 */
export function createProject(data) {
  return action(POC_MNG, 'create', data)
}

/**
 * 修改项目
 * @param {*} data
 * @returns
 */
export function editProject(data) {
  return action(POC_MNG, 'edit', data)
}

/**
 * 查询项目
 * @param {*} data
 * @returns
 */
export function getDetail(data) {
  return action(POC_MNG, 'detail', data)
}

/**
 * 查询项目友商
 * @param {*} data
 * @returns
 */
export function getProjectCompetitor(data) {
  return action(POC_MNG, 'getProjectCompetitor', data)
}

/**
 * 复制项目
 * @param {*} data
 * @returns
 */
export function copyPocProject(data) {
  return action(POC_MNG, 'copyPocProject', data)
}

/**
 * 设置模板项目
 * @param {*} data
 * @returns
 */
export function SetPocProjectTemplate(data) {
  return action(POC_MNG, 'setPocProjectTemplate', data)
}

/**
 * 方案确认项目
 * @param {*} data
 * @returns
 */
export function SetRequestConfirm(data) {
  return action(POC_MNG, 'setRequestConfirm', data)
}

/**
 * 查询模块项目列表
 * @param {*} data
 * @returns
 */
export function getTemplateProjectList(data) {
  return action(POC_MNG, 'template/list', data)
}

/**
 * 保存缓存数据
 * @param {*} data
 * @returns
 */
export function saveTempStepData(data) {
  return action(STEP_DATA, 'save', data)
}

/**
 * 获取缓存数据
 * @param {*} data
 * @returns
 */
export function getTempStepData(data) {
  return action(STEP_DATA, 'detail', data)
}

/**
 * 整个项目概要
 * @param {*} data
 * @returns
 */
export function getDetailOverview(data) {
  return action(POC_MNG, 'overview', data)
}

/**
 * 整个项目规格变更提示
 * @param {*} data
 * @returns
 */
export function getProjectMonitorChangeDetail(data) {
  return action(PROJECT_MONITOR, 'change/detail', data)
}

/**
 * 规格变更详情
 * @param {*} data
 * @returns
 */
export function getChangeItemDetail(data) {
  return action(PROJECT_MONITOR, 'change/itemDetail', data)
}

/**
 * 获取实例的软件兼容性列表
 * @param {*} data
 * @returns
 */
export function getInstBlackSoftwareList(data) {
  return action(EVN_CONFIRM_MNG, 'software/black/list', data)
}
